<template>
  <!-- Eén badge, vier toestanden (Figma "wachtlijst badge" 18168:160469):
       Volgeboekt · 8 op wachtlijst · Plek 9 op wachtlijst · Definitief
       ingeschreven. Op de activiteitpagina, het dashboard en bij de tijdsloten
       dezelfde (ClickUp 1240ccedm9c). -->
  <v-tooltip :disabled="!tooltip" location="top" class="rounded-tooltip">
    <template v-slot:activator="{ props }">
      <span
        class="waitlist-chip"
        :class="{ 'icon-only': iconOnly, 'waitlist-chip--large': large }"
        v-bind="{ ...props, ...$attrs }"
      >
        <img
          :src="icon"
          alt=""
          class="waitlist-chip__icon"
          :width="large ? 24 : 16"
          :height="large ? 24 : 16"
        />
        <i18n-t v-if="!iconOnly" :keypath="labelKey" tag="span" class="waitlist-label">
          <template #n><strong>{{ number }}</strong></template>
        </i18n-t>
      </span>
    </template>
    <span class="tooltip-text">{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import lockIcon from "@/assets/img/lock.svg";
import lockClockIcon from "@/assets/img/lock-clock.svg";
import checkIcon from "@/assets/img/check.svg";

export default {
  inheritAttrs: false,
  props: {
    // full: vol zonder wachtlijst · waitlist: vol met wachtlijst (count) ·
    // position: jij staat erop (position) · enrolled: definitief ingeschreven.
    status: {
      type: String,
      default: "waitlist",
    },
    // Hoeveel er wachten. Zonder getal (een oudere payload) blijft het "Wachtlijst".
    count: {
      type: Number,
      default: null,
    },
    position: {
      type: Number,
      default: null,
    },
    tooltip: {
      type: String,
      default: "",
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    // Het 40px-slotje in "Jouw aanmeldingen" (Figma 18141:153035).
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      if (this.status === "full") return lockIcon;
      if (this.status === "enrolled") return checkIcon;
      return lockClockIcon;
    },
    labelKey() {
      if (this.status === "full") return "waitlist.badge_full";
      if (this.status === "enrolled") return "waitlist.badge_enrolled";
      if (this.status === "position") {
        return this.position ? "waitlist.badge_position" : "waitlist.badge";
      }
      if (this.count === null) return "waitlist.badge";
      return this.count > 0 ? "waitlist.badge_count" : "waitlist.badge_empty";
    },
    number() {
      return this.status === "position" ? this.position : this.count;
    },
  },
};
</script>
